import { TextFieldFilterOperationType } from 'module/types/filter-field/filter/text';
import { FormattedMessage } from 'react-intl';

export const textTriggerOptionRenderers = (
  operationType: TextFieldFilterOperationType,
): null | React.JSX.Element => {
  switch (operationType) {
    case TextFieldFilterOperationType.Contains: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.contains" />
      );
    }

    case TextFieldFilterOperationType.DoesNotContain: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.does_not_contain" />
      );
    }

    case TextFieldFilterOperationType.IsEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_empty" />
      );
    }

    case TextFieldFilterOperationType.IsNotEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_not_empty" />
      );
    }

    default: {
      return null;
    }
  }
};
